"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERC1967Utils__factory = void 0;
var _ethers = require("ethers");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const _abi = [{
  inputs: [{
    internalType: "address",
    name: "admin",
    type: "address"
  }],
  name: "ERC1967InvalidAdmin",
  type: "error"
}, {
  inputs: [{
    internalType: "address",
    name: "beacon",
    type: "address"
  }],
  name: "ERC1967InvalidBeacon",
  type: "error"
}, {
  inputs: [{
    internalType: "address",
    name: "implementation",
    type: "address"
  }],
  name: "ERC1967InvalidImplementation",
  type: "error"
}, {
  inputs: [],
  name: "ERC1967NonPayable",
  type: "error"
}];
const _bytecode = "0x60566050600b82828239805160001a6073146043577f4e487b7100000000000000000000000000000000000000000000000000000000600052600060045260246000fd5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600080fdfea2646970667358221220c14f6e2f23e3b5775c2fc5e7b93621dba3035f0cc8c0f2db6066596925f925a364736f6c63430008160033";
const isSuperArgs = xs => xs.length > 1;
class ERC1967Utils__factory extends _ethers.ContractFactory {
  constructor(...args) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }
  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }
  deploy(overrides) {
    return super.deploy(overrides || {});
  }
  connect(runner) {
    return super.connect(runner);
  }
  static createInterface() {
    return new _ethers.Interface(_abi);
  }
  static connect(address, runner) {
    return new _ethers.Contract(address, _abi, runner);
  }
}
exports.ERC1967Utils__factory = ERC1967Utils__factory;
_defineProperty(ERC1967Utils__factory, "bytecode", _bytecode);
_defineProperty(ERC1967Utils__factory, "abi", _abi);